import type { StatusTone } from '@/components/ui/status-badge';

import type { ClientStateDto } from '@/api/clients-client';

// =============================================================================
// client-labels.ts — Mapping enum d'état Client ASCII (API) → libellé FR + variant.
// =============================================================================
// L'API porte un enum ASCII (parité Prisma ClientState) ; l'UI le rend en libellé FR
// accentué (i18n front). WCAG 2.1 AA : la COULEUR n'est JAMAIS le seul porteur
// d'information — chaque état rend un LIBELLÉ TEXTE ; le variant de badge n'est qu'un
// renfort visuel. Aucune règle métier ici : table de traduction pure.

/** Couple libellé FR + tone DS pour un statut de compte (StatusBadge, DS Cat 1). */
interface LabelWithTone {
  readonly label: string;
  readonly tone: StatusTone;
}

/** 2 états Client → libellés FR + tone DS (mapping canonique Cat 1, DDD §3.3.4). */
const CLIENT_STATE_LABELS: Record<ClientStateDto, LabelWithTone> = {
  Actif: { label: 'Actif', tone: 'active' },
  Archive: { label: 'Archivé', tone: 'inactive' },
};

/** Libellé FR + tone DS d'un état de client. */
export function clientStateLabel(state: ClientStateDto): LabelWithTone {
  return CLIENT_STATE_LABELS[state];
}
